export const initGoogleAnalytics = (measurementId: string) => {
  if (typeof window === 'undefined') return;

  const scriptAlreadyExists = Array.from(document.scripts).some(
    (script) =>
      script.src.includes('https://www.googletagmanager.com/gtag/js') &&
      script.src.includes(measurementId)
  );
  if (scriptAlreadyExists) return;

  // Загружаем внешний скрипт
  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  script.async = true;
  document.head.appendChild(script);

  // Настройка конфигурации GA
  script.onload = () => {
    window.dataLayer = window.dataLayer || [];
    function gtag(...args: any[]) {
      window.dataLayer.push(args);
    }
    window.gtag = gtag;

    gtag('js', new Date());
    gtag('config', measurementId);
    console.log('[GA] Initialized with ID:', measurementId);
  };
};
